import React from "react";
import Group286 from "../Group286";
import Group256 from "../Group256";
import Group258 from "../Group258";
import "./Property1Frame182.css";

function Property1Frame182(props) {
  const {
    rectangle201,
    rosewaterBenefits1,
    rectangle202,
    excitingEyeMakeupTrendsIn2021,
    rectangle203,
    rosewaterBenefits2,
    group2861Props,
    group2862Props,
    group256Props,
    group258Props,
  } = props;

  return (
    <div className="blogs">
      <div className="group-container-1">
        <div className="overlap-group2">
          <div className="blog-3">
            <img className="rectangle-20-1" src={rectangle201} />
            <p className="rosewater-benefits poppins-normal-tundora-15px">{rosewaterBenefits1}</p>
          </div>
          <Group286 src={group2861Props.src} />
          <Group286 src={group2862Props.src} className={group2862Props.className} />
        </div>
        <div className="group-257-2">
          <div className="ellipse-25-2"></div>
          <div className="ellipse-2"></div>
          <div className="ellipse-2"></div>
        </div>
      </div>
      <div className="flex-col-5">
        <div className="blog-4">
          <img className="rectangle-20" src={rectangle202} />
          <p className="exciting-eye-makeup-trends-in-2021 poppins-normal-tundora-15px">
            {excitingEyeMakeupTrendsIn2021}
          </p>
        </div>
        <Group256 className={group256Props.className} />
      </div>
      <div className="flex-col-6">
        <div className="blog-5">
          <img className="rectangle-20" src={rectangle203} />
          <p className="rosewater-benefits-1 poppins-normal-tundora-15px">{rosewaterBenefits2}</p>
        </div>
        <Group258 className={group258Props.className} />
      </div>
    </div>
  );
}

export default Property1Frame182;
